import { inject, Pipe, PipeTransform } from '@angular/core';
import { Gender } from '../models';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
    name: 'genderLabel',
    standalone: true,
    pure: true
})
export class GenderLabelPipe implements PipeTransform {
    private readonly translocoService = inject(TranslocoService);

    transform(value: Gender): string {
        switch (value) {
            case Gender.Other:
                return this.translocoService.translate('gender.other');
            case Gender.Male:
                return this.translocoService.translate('gender.male');
            case Gender.Female:
                return this.translocoService.translate('gender.female');
        }
    }
}
